module.exports = __webpack_public_path__ + "static/media/super-word-rgb.75bc54c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/super-word-rgb.png
// module id = 1540
// module chunks = 0